import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from "@angular/core";
import { GigyaService } from "../../../services/gigya.service";
import { OrganizationPickerService } from "../../../services/organization-picker.service";
import { LayoutComponent } from "../../../shared/layout/layout.component";
import { SpinnerComponent } from "../../../shared/icons/spinner/spinner.component";
import { TitleComponent } from "../../../shared/title/title.component";
import { ChevronRightIconComponent } from "../../../shared/icons/chevron-right/chevron-right.component";

@Component({
  selector: "app-picker",
  standalone: true,
  imports: [LayoutComponent, SpinnerComponent, TitleComponent, ChevronRightIconComponent],
  templateUrl: "./picker.component.html",
  styleUrl: "./picker.component.css",
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PickerComponent implements OnInit {
  public organizations: any[] = [];
  public loading = false;
  public noOrganization = false;

  constructor(
    private gigyaService: GigyaService,
    private organizationPicker: OrganizationPickerService,
  ) { }

  public ngOnInit(): void {
    this.organizations = (this.gigyaService.data as any)?.groups?.organizations ?? [];
    this.noOrganization = this.organizations.length === 0;
    console.info("PickerComponent.ngOnInit - organizations count:", this.organizations.length);
    if (this.noOrganization) {
      console.warn("PickerComponent.ngOnInit - user landed on /picker with ZERO organizations - this is a dead end for the user.");
    }
  }

  public useOrganization(org: any): void {
    console.info("PickerComponent.useOrganization - user manually selected organization bpid:", org?.bpid);
    this.loading = true;
    this.organizationPicker.useOrganization(org);
  }
}
